//========== Experience Section Component ==========

import { useState, useEffect } from "react";
import { ReactComponent as WorkIcon } from "../../assets/img/Icons-img/work.svg";
import { ReactComponent as SchoolIcon } from "../../assets/img/Icons-img/school.svg";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { useInView } from "react-intersection-observer";
import "./experience.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ExperienceTimeline({
  timelineElements
}) {
  const {
    ref,
    inView
  } = useInView({
    triggerOnce: false,
    threshold: 0.1
  });
  const [key, setKey] = useState(0);
  useEffect(() => {
    if (inView) {
      setKey(prevKey => prevKey + 1);
    }
  }, [inView]);
  let workIconStyles = {
    background: "#06D6A0"
  };
  let schoolIconStyles = {
    background: "#f9c74f"
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "experience",
    id: "experience",
    ref: ref,
    children: [/*#__PURE__*/_jsxs("h2", {
      className: "heading",
      children: [/*#__PURE__*/_jsx("i", {
        className: "fas fa-hourglass"
      }), " Experience", " ", /*#__PURE__*/_jsx("span", {
        className: "timelineSpan",
        children: "Timeline"
      })]
    }), /*#__PURE__*/_jsx(VerticalTimeline, {
      children: timelineElements.map(element => {
        let isWorkIcon = element.icon === "work";
        let showButton = element.buttonText && element.buttonText !== "";
        return /*#__PURE__*/_jsxs(VerticalTimelineElement, {
          date: element.date,
          dateClassName: "date",
          iconStyle: isWorkIcon ? workIconStyles : schoolIconStyles,
          icon: isWorkIcon ? /*#__PURE__*/_jsx(WorkIcon, {}) : /*#__PURE__*/_jsx(SchoolIcon, {}),
          children: [/*#__PURE__*/_jsx("h3", {
            className: "vertical-timeline-element-title",
            children: element.title
          }), /*#__PURE__*/_jsx("h4", {
            className: "vertical-timeline-element-subtitle",
            children: element.location
          }), /*#__PURE__*/_jsx("p", {
            id: "description",
            children: element.description
          }), showButton && /*#__PURE__*/_jsx("a", {
            className: `button ${isWorkIcon ? "workButton" : "schoolButton"}`,
            href: "/",
            children: element.buttonText
          })]
        }, element.id);
      })
    }, key)]
  });
}
export default ExperienceTimeline;